// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebar/SubmitButton.js
import React from 'react';
import { Button, ProgressSpinner } from 'primereact';

const SubmitButton = ({ loading, handleSubmitClick, cumulativePrice, translations = {} }) => {
  const formattedCumulativePrice = (cumulativePrice || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className="d-flex align-items-center justify-content-end">
      {loading ? (
        <ProgressSpinner />
      ) : (
        <Button onClick={handleSubmitClick} className="full-submit-button">
          <div className="confirm-button-content">
            <div className="confirm-text">{translations.sidebar?.label || "CONFIRM"}</div>
            <div className="cumulative-total-text">
              {translations.sidebar?.button || "CUMULATIVE TOTAL:"} {translations.sidebar ? formattedCumulativePrice : `$${cumulativePrice}`}
            </div>
          </div>
        </Button>
      )}
    </div>
  );
};

export default SubmitButton;